import {mapState, mapMutations, mapGetters} from "vuex";
import {projectItem} from "../projects/projectItem";
import {sidebarState} from "../utils/sidebarState";

export const dragNdrapProjects = {
  mixins: [sidebarState],
  computed: {
    ...mapState({
      isOpen: state => state.openProjectsNavigator,
      currentDroppableVuex: state => state.projects.currentDroppable,
      movedElVuex: state => state.projects.movedEl,
      movedXVuex: state => state.projects.movedX,
      movedYVuex: state => state.projects.movedY,
      movedGroupVuex: state => state.projects.movedGroup,
      dopElemOnDragVuex: state => state.projects.dopElemOnDrag,
      draggedElVuex: state => state.projects.draggedEl,
      deltaXVuex: state => state.projects.deltaX,
      deltaYVuex: state => state.projects.deltaY,
      dragXVuex: state => state.projects.dragX,
      dragYVuex: state => state.projects.dragY,
      hiddenElVuex: state => state.projects.hiddenEl,
      drugConfig: state => state.projects.drugConfig,
      activeZoom: state => state.projects.activeZoom,
      defaultRole: state => state.auth.user,
    }),
    ...mapGetters({
      isAdminRole: 'auth/adminRole'
    }),
    currentDroppable: {
      get() {
        return this.currentDroppableVuex;
      },
      set(val) {
        this.SET_CURRENT_DROPPABLE(val)
      }
    },
    movedEl: {
      get() {
        return this.movedElVuex;
      },
      set(val) {
        this.SET_MOVED_EL(val)
      }
    },
    movedX: {
      get() {
        return this.movedXVuex
      },
      set(val) {
        this.SET_MOVED_X(val)
      }
    },
    movedY: {
      get() {
        return this.movedYVuex
      },
      set(val) {
        this.SET_MOVED_Y(val)
      }
    },
    movedGroup: {
      get() {
        return this.movedGroupVuex
      },
      set(val) {
        this.SET_MOVED_GROUP(val)
      }
    },
    dopElemOnDrag: {
      get() {
        return this.dopElemOnDragVuex
      },
      set(val) {
        this.SET_DOP_ELEM_ON_DRAG(val)
      }
    },
    draggedEl: {
      get() {
        return this.draggedElVuex
      },
      set(val) {
        this.SET_DRAGGED_EL(val)
      }
    },
    deltaX: {
      get() {
        return this.deltaXVuex
      },
      set(val) {
        this.SET_DELTA_X(val)
      }
    },
    deltaY: {
      get() {
        return this.deltaYVuex
      },
      set(val) {
        this.SET_DELTA_Y(val)
      }
    },
    dragX: {
      get() {
        return this.dragXVuex
      },
      set(val) {
        this.SET_DRAG_X(val)
      }
    },
    dragY: {
      get() {
        return this.dragYVuex
      },
      set(val) {
        this.SET_DRAG_Y(val)
      }
    },
    hiddenEl: {
      get() {
        return this.hiddenElVuex
      },
      set(val) {
        this.SET_HIDDEN_EL(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_CURRENT_DROPPABLE: 'projects/SET_CURRENT_DROPPABLE',
      SET_MOVED_EL: 'projects/SET_MOVED_EL',
      SET_MOVED_X: 'projects/SET_MOVED_X',
      SET_MOVED_Y: 'projects/SET_MOVED_Y',
      SET_MOVED_GROUP: 'projects/SET_MOVED_GROUP',
      SET_DOP_ELEM_ON_DRAG: 'projects/SET_DOP_ELEM_ON_DRAG',
      SET_DRAGGED_EL: 'projects/SET_DRAGGED_EL',
      SET_DELTA_X: 'projects/SET_DELTA_X',
      SET_DELTA_Y: 'projects/SET_DELTA_Y',
      SET_DRAG_X: 'projects/SET_DRAG_X',
      SET_DRAG_Y: 'projects/SET_DRAG_Y',
      SET_HIDDEN_EL: 'projects/SET_HIDDEN_EL'
    }),
    removeAllHandlers() {
      let elems = document.querySelectorAll('.movedClass');

      elems.forEach(item => {
        item.classList.remove('moved_class');
        item.style.left = 0;
        item.style.top = 0;
      });
      let elemsDrop = document.querySelectorAll(`.${this.drugConfig.dropActive}`);
      elemsDrop.forEach(item => {
        item.classList.remove(this.drugConfig.dropActive);
      });

      this.movedEl ='';
      this.movedX = '';
      this.movedY = '';
      this.draggedEl = '';
      this.deltaY = '';
      this.deltaX = '';
      this.dragX = '';
      this.dragY = '';

      document.removeEventListener('mousemove', this.mouseMove);
    },
    clearAll() {
      this.movedGroup = '';
    },

    setDelta(e) {
      // const scrollField = document.querySelector('.project-tree-scrollwrap ');
      // const scrollFieldTop = scrollField.scrollTop;
      // const scrollFiledLeft = scrollField.scrollLeft;

      if (this.activeZoom) {
        this.deltaX = e.clientX + 73;
        this.deltaY = e.clientY - 140;
      } else {
        this.deltaX = e.clientX; // - 30// - 22;
        this.deltaY = e.clientY// + 90// + 100;
      }
    },

    dragStart(item,evt,config) {
      evt.preventDefault();

      //запретить перемещение всем ролям
      if (!this.isAdminRole) return

      //получаем элемент
      let ref = `${config.refName}${item.id}`;
      let elem = this.$refs[ref];

      let offsetY = 90;
      if (item.items.length > 0) {
        offsetY = 60;
        if (this.activeZoom) {
          offsetY += 30
        }
      }

      let offsetX = 0;
      if (this.isOpen) {
        offsetX = 220
      }

      if (elem) {
        //получаем координаты элемента
        this.movedX = this.deltaX - elem.getBoundingClientRect().left + offsetX;
        this.movedY = this.deltaY - elem.getBoundingClientRect().top + config.y + offsetY;

        //учитывая при этом сайдбар
        //и полноэкранный режим
        if (!this.activeZoom) {
          if (this.sidebarOpen) {
            this.movedX += +config.fullX
          } else {
            this.movedX += +config.closedX
          }
        }

        //добавляем класс для визуала
        setTimeout(() => {
          //elem.classList.add('moved_class-opacity')
          elem.parentElement.classList.add('moved_class-opacity')
          this.isNoMove()
        }, 0);
        //записываем элемент в стэйт
        this.draggedEl = item;
      };

      //отслеживаем перемещение мыши
      document.addEventListener('mousemove', this.mouseMove)
    },
    mouseMove(e,config) {
      if (this.draggedEl) {
        let dopFlag = false
        //двигаем элемент
        let shiftX = this.movedX;
        let posX = e.pageX - shiftX;

        let shiftY = this.movedY;
        let posY = e.pageY - shiftY;

        this.dragX = posX;
        this.dragY = posY;

        //получаем скрытый элемент
        let hiddenEl = document.querySelector('.hidden-project-item');
        hiddenEl.classList.add('hiddenClass');

        //элемен под перемещаемым
        let elemBelow = document.elementFromPoint(e.clientX, e.clientY);
        hiddenEl.classList.remove('hiddenClass');

        if (!elemBelow) return;
        let droppableBelow = elemBelow.closest(this.drugConfig.dropzone);

        // проверка на наведение невидимых хон
        if (droppableBelow && droppableBelow.classList.length > 0) {
          droppableBelow.classList.forEach((className) => {
            if (className === 'dop-node') {
              dopFlag = true
              this.addNodeOnDrag(droppableBelow)
            }
          })
        }

        if (this.currentDroppable != droppableBelow && !dopFlag) {
          if (this.currentDroppable) {
            //вылет
            this.leaveGroup()
          }

          this.currentDroppable = droppableBelow;
          if (this.currentDroppable) {
            //вход
            if (this.currentDroppable.classList.contains('item-blocked')) {
              return;
            }

            this.enterGroup()
          }
        }

      }
    },
    leaveGroup() {
      let allActiveDopElem = document.getElementsByClassName('colorTest')
      if (allActiveDopElem.length > 0) {
        allActiveDopElem.forEach((item) => {
          item.classList.remove('colorTest')
        })
      }
      let elem = this.currentDroppable;
      if (elem) {
        elem.classList.remove(this.drugConfig.dropActive);
        this.movedGroup = false;
      }
    },
    enterGroup() {
      let elem = this.currentDroppable;
      elem.classList.add(this.drugConfig.dropActive);
      let id = elem.getAttribute(this.drugConfig.attr);
      this.movedGroup = id;
    }
  }
}
